import React from "react";
import { Link } from "react-router-dom";
import {
  formatDate,
  getOrderStatusBadge,
  getPaymentStatusBadge,
  getInitials,
} from "../../helper/Helper";

function SortableRow({
  order,
  selectedOrders,
  handleSelectOne,
  setSelectedOrder,
}) {
  return (
    <tr key={order._id}>
      <td>
        <label className="checkboxs">
          <input
            type="checkbox"
            checked={selectedOrders.includes(order._id)}
            onChange={() => handleSelectOne(order._id)}
          />
          <span className="checkmarks" />
        </label>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <span className="avatar avatar-lg bg-primary text-white">
            {getInitials(
              order?.userId?.firstName + " " + order?.userId?.lastName,
            )}
          </span>
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to={`/customer/details/${order?.userId?._id}`}>
                {order?.userId?.firstName} {order?.userId?.lastName}
              </Link>
              <br />
              {order?.email && (
                <a className="text-info fs-10" href={`mailto:${order.email}`}>
                  {order.email}
                </a>
              )}
              <br />
              {order?.phone && (
                <a className="text-info fs-10" href={`tel:${order.phone}`}>
                  +91-{order.phone}
                </a>
              )}
            </h6>
          </div>
        </div>
      </td>
      <td>
        <Link to={`/orders/details/${order.orderId}`} className="text-primary">
          #{order.orderId}
        </Link>
        <br />
        <span className="fs-10">{order.createdAt && formatDate(order.createdAt)}</span>
      </td>
      <td>
        <div className={`badge ${getOrderStatusBadge(order.status)}`}>
          {order.status}
        </div>

        {order.status !== "delivered" && order?.statusHistoryAwb?.awb && (
          <div>
            <a
              href={order?.statusHistoryAwb?.trackingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-sm mt-1 btn-outline-primary"
            >
              Tracking Status
            </a>
          </div>
        )}
        
      </td>
      <td>
        <div className="fs-sm">{order?.payment?.details?.gatewayOrderId}</div>
        <div className="fs-sm">{order?.payment?.details?.id}</div>
        <div
          className={`badge ${getPaymentStatusBadge(order?.payment?.status)}`}
        >
          {order?.payment?.status || "N/A"}
        </div>
      </td> 

      <td className="fw-medium">
        ₹
        {Number(order.total || 0).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
        /-
      </td>
      <td>
        <button
          className="btn btn-sm btn-outline-primary me-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasShipment"
          aria-controls="offcanvasShipment"
          onClick={() => setSelectedOrder(order)}
        >
          Shipment Details
        </button>

        <Link
          to={`/orders/details/${order.orderId}`}
          className="btn btn-primary btn-sm"
        >
          View Details
        </Link>
      </td>
    </tr>
  );
}

export default SortableRow;
